import { Hero } from '@/features/home/components/hero/hero';
import { VisionMision } from '@/features/home/components/vision-mision/vision-mision';
import { SeccionSocios } from '@/features/home/components/seccion-socios/seccion-socios';
import { useDocumentTitle } from '@/shared/hooks/use-document-title';

export function HomePage(): React.ReactElement {
  useDocumentTitle('Inicio');

  return (
    <main>
      <Hero />
      <VisionMision />
      <SeccionSocios />
    </main>
  );
}
